export enum TodosType {
  all = 'All',
  active = 'Active',
  completed = 'Completed',
}
